import type { CSSProperties } from "react";
import "./BouncingDotsLoader.css";

const BouncingDotsLoader = (props : { style?: CSSProperties }) => {
  return (
    <div className="bouncing-loader">
      <div style={props.style}></div>
      <div style={props.style}></div>
      <div style={props.style}></div>
    </div>
  );
};

export default BouncingDotsLoader;
